import { BrowserRouter as Router, Routes, Route , useLocation} from 'react-router-dom';
import React, { useEffect } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { analytics } from './firebase'; // Adjust the import path as necessary
import { Layout } from 'antd';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Article from './pages/Article';
import BlogUpload from './pages/Admin/BlogUpload';
import BlogDashboard from './pages/Admin/Dashboard';
import BlogEdit from './pages/Admin/BlogEdit';
import './App.css';


const TrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title
    });
  }, [location]);

  return null;
};

function App() {

  useEffect(() => {
    // Log that the app loaded
    logEvent(analytics, 'app_loaded');
  }, [])


  return (
    <Router>
      <TrackPageViews />  
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/article/:id" element={<Article />} />
          {/* <Route path="/admin" element={<BlogDashboard />} />
<Route path="/admin/new" element={<BlogUpload />} />
<Route path="/admin/edit/:id" element={<BlogEdit />} /> */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;